if (!customElements.get('foundation-ingredients')) {
  customElements.define('foundation-ingredients', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.formthr-ingredients-button');
      this.trigger.addEventListener('click', () => {
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.querySelector('.formthr-ingredients-drawer__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        if (this.trigger.isConnected) this.trigger.focus();
      });
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
    }
  });
}
